import { render, staticRenderFns } from "./CoventryAddress.vue?vue&type=template&id=724c01c3&"
import script from "./CoventryAddress.vue?vue&type=script&lang=js&"
export * from "./CoventryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports